import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import DetailsBasicsContainer from './Basics/DetailsBasicsContainer';
import DetailsRangesContainer from './Ranges/DetailsRangesContainer';
import DetailsExcessContainer from './Excess/DetailsExcessContainer';
import DetailsQuantitiesContainer from './Quantities/DetailsQuantitiesContainer';
import DetailsOptionsContainer from './Options/DetailsOptionsContainer';
import DetailsOtherRangesContainer from './OtherRanges/DetailsOtherRangesContainer';
import DetailsFixedAmountContainer from './FixedAmount/DetailsFixedAmountContainer';
import DetailsQuantityMatrixContainer from './QuantityMatrix/DetailsQuantityMatrixContainer';

import * as c from '../../constant';
import * as actions from '../../action';

function DetailsContainer({
  newTaxRevenuesId,
  calculationsId,
  calculationsInfo,
  getDetailsList,
  detailsList,
}) {
  const type = _.get(calculationsInfo, 'included.type.attributes.type');

  useEffect(() => {
    if (!newTaxRevenuesId || !calculationsId) return;

    if (newTaxRevenuesId && calculationsId) {
      const timeout = setTimeout(() => {
        getDetailsList(newTaxRevenuesId, calculationsId);
      }, 500);

      // eslint-disable-next-line consistent-return
      return () => clearTimeout(timeout);
    }

  }, [newTaxRevenuesId, calculationsId]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="right-section-content py-2 my-2">
          <div className="d-flex flex-row align-items-center">
            <div className="px-3">{/* <h3 className="m-0">Details</h3> */}</div>
          </div>
        </div>
      </div>

      <div className="col-12 d-flex flex-row">
        <div className="container">
          <div>
            {type === 'BASIC' ? (
              <DetailsBasicsContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'AMOUNT_RANGE' ? (
              <DetailsRangesContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'EXCESS' ? (
              <DetailsExcessContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'QUANTITY' ? (
              <DetailsQuantitiesContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'OTHER_RANGE' ? (
              <DetailsOtherRangesContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'OPTION' ? (
              <DetailsOptionsContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'FIXED_AMOUNT' ? (
              <DetailsFixedAmountContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {type === 'QUANTITY_MATRIX' ? (
              <DetailsQuantityMatrixContainer
                newTaxRevenuesId={newTaxRevenuesId}
                calculationsId={calculationsId}
                detailsList={detailsList}
                type={type}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

DetailsContainer.propTypes = {
  calculationsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  detailsList: PropTypes.instanceOf(Object).isRequired,
  calculationsInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api}) => ({
  detailsList: _.get(api, `${c.GET_DETAILS_GARBAGE}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DetailsContainer);
